import classNames from "classnames";
import styles from "./styles.module.scss";
import { ReactNode } from "react";
import { Stack } from "@altimateai/lego";

type Props = {
  title: string;
  value: string | ReactNode;
};
const ColumnRow = ({ title, value }: Props) => {
  return (
    <div className={classNames(styles.column_card, {})}>
      <Stack direction="row" align="center" gap="xs">
        <div className="lines-2">{title}</div>
        <div className="spacer" />
      </Stack>
      <Stack direction="column">
        <div className="font-normal fs-xxs text-grey">{value}</div>
      </Stack>
    </div>
  );
};

export default ColumnRow;
